<ng-content></ng-content>
<span
  class="icons__sort-block"
  [ngClass]="{
    'icons__asc-sort': sortDirection === 'asc',
    'icons__desc-sort': sortDirection === 'desc'
  }"
>
  <app-icon [class]="'icon__down'" [size]="'16'" [glyph]="'hd-arrow-down'"></app-icon>
  <app-icon [class]="'icon__up'" [size]="'16'" [glyph]="'hd-arrow-up'"></app-icon>
</span>
